export const sanitizeQueryParams = <T extends Record<string, unknown>>(
  params: T,
) =>
  Object.fromEntries(
    Object.entries(params).map(([key, value]) => [
      key,
      value === '' || value === undefined ? null : value,
    ]),
  );
